const VISUAL_ONLY_SUFFIXES = [
  '_approved',
  '_rejected',
  '_approved_by_you',
  '_rejected_by_you',
];

const isVisualOnly = (type) => {
  if (typeof type !== 'string' || type === '') return false;
  return VISUAL_ONLY_SUFFIXES.some((suffix) => type.endsWith(suffix));
};

export const stripAnchorsIfVisualOnly = (type, message) => {
  if (!isVisualOnly(type) || typeof message !== 'string' || message === '') {
    return message;
  }
  return message.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '$1');
};
